import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomButton from "../Buttons/Button";
import { deleteStock } from "../../store/actions/stocks/deleteStock";

function DeleteStockModal({ open, onClose, stock }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state?.stocks?.deletePending);

  const handleDelete = () => {
    dispatch(
      deleteStock({
        id: stock?.id,
        callback: onClose,
        navigate,
      })
    );
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 480,
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 2,
        }}
      >
        <IconButton
          aria-label="close"
          sx={{ position: "absolute", top: 19, right: 10 }}
          onClick={onClose}
        >
          <ClearIcon />
        </IconButton>

        <div className="w-full p-3">
          <img src="/Assets/approveIcon.png" alt="" className="w-12 h-12 mb-5" />
          <h1 className="font-semibold text-2xl mb-4">Delete Stock</h1>
          <p className="text-sm mb-10">
            Are you sure you want to delete {stock?.symbol || "this stock"}? This
            action cannot be undone.
          </p>

          <div className="flex mt-6 w-full items-center">
            <CustomButton
              variant="outlined"
              customColor="#fff"
              children="Cancel"
              width="100%"
              height="44px"
              borderColor="#D0D5DD"
              color="#344054"
              margin="0px 25px 0px 0px"
              onClick={onClose}
            />
            <CustomButton
              variant="contained"
              customColor="#B42318"
              children="Delete"
              width="100%"
              height="44px"
              loading={loading}
              padding="10px"
              color="#fff"
              onClick={handleDelete}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default DeleteStockModal;
